<template>
  <!-- //ROUTER IF MOBILE -->
  <ion-content class="d-flex wrapper" v-if="isMobile" >
      <div class="block block__browse">

          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 
  <!-- //ROUTER IF MOBILE -->

  <!-- //ROUTER IF DESKTOP -->
  <section class="d-flex wrapper" v-else>
      <div class="block block__browse">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </section> 
  <!-- //ROUTER IF DESKTOP -->
</template>


<script>
import CatMixin from './CatMixin'
import { mapGetters } from 'vuex'

export default {
  name:"browse",
    components:{ },
    mixins: [
      CatMixin
    ],
    computed: {
      ...mapGetters([
      ])
    },
};
</script>
